import React, { ReactNode } from 'react'
import { Link } from 'react-router-dom'

import { bemJoin } from 'bem-join'
import { CounterBubble } from 'component-library-next'

import './PageTab.scss'

export type PageTabProps = {
  counter?: number
  link: string
  isSelected: boolean
  icon?: ReactNode
  label: ReactNode
}

export const PageTab = ({ counter, link, isSelected, icon, label }: PageTabProps) => {
  const b = bemJoin('page-tab')

  return (
    <Link
      to={link}
      className={b({
        selected: isSelected
      })}
    >
      {icon}
      <span>{label}</span>
      {counter && (
        <span className={b('counter')}>
          <CounterBubble counter={counter} />
        </span>
      )}
    </Link>
  )
}
